import { gql } from "@apollo/client";

export const GET_EVENTS = gql`
  query GetEvents($where: events_bool_exp) {
    events(where: $where, order_by: { name: asc }) {
      id
      name
    }
  }
`;

export const GET_TIMECLOCK_REPORT = gql`
  query GetTimeclockReport($eventId: Int!) {
    timeclock_entries(
      where: { event_id: { _eq: $eventId } }
      order_by: { clock_in: desc }
    ) {
      id
      worker_id
      event_id
      clock_in
      clock_out
      worker {
        id
        name
        hourly_rate
        vendor_id
        vendor {
          id
          name
        }
        worker_role_assignments {
          worker_role {
            name
          }
        }
      }
    }
  }
`;
